import logo from './logo.svg';
import './App.css';
import Header from './Header';
import { MainContent, ContactForm } from './MainContent';
import Footer from './Footer';

function App() {
  return (
    <div>
      <Header />
      <MainContent />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;
